export class HierarchyItem {
  order?: number;
  id!: string;
  alternativeCode!: string;
  name?: string;
}
